const baseUrl = import.meta.env.VITE_BASEURL;

const API_URL = {
  base: baseUrl,
  dashboard: {
    listing: 'api/reports/dashboardStats',
    reportListing: 'api/reports/dashboardReport',
    codListing: 'api/reports/codSummaryReport',
    orderGraph: 'api/reports/orderStatusChartData',
    shipmentGraph: 'api/reports/carrierChartData'
  },
  transaction_master: {
    listing: 'api/transaction/get'
  },
  wallet_master: {
    walletData: 'api/wallet/getWalletData',
    add: 'api/wallet/rechargeWallet',
    create: 'api/wallet/createRechargeOrderRyp',
    verify: 'api/wallet/verifyPaymentRpy',
    phonepe: 'api/wallet/createRechargeOrder',
    phonepeStatus: 'api/wallet/setPaymentStatus'
  },

  auth: {
    singup: 'customer/create',
    signup: 'customer/create',
    sendRegistrationEmail: 'customer/sendRegistrationEmail',
    verifyRegistrationOTP: 'customer/verifyRegistrationOTP'
  },
  customerAuth: {
    login: 'customer/login'
  },
  passwordreset: {
    reset: 'customer/reset-password',
    verifyotp: 'customer/verify-otp',
    updatePassword: 'customer/update-password'
  },
  refreshToken: {
    token: 'auth-user/refresh-token'
  },
  pincode: {
    commonListing: 'pincode/getPincodeDataForDropdown'
  },
  user: {
    listing: 'api/customer/get',
    update: 'api/customer/update'
  },
  address: {
    listing: 'api/address/get'
  },
  trackData: {
    trackDelhivery: 'trackDelhiveryShipment',
    dtdcTrackDetails: 'trackDTDCShipment',
    EkartTrackDetails: 'trackEkartShipment',
    xpressbeesTrackDetails: 'trackXpressbeesShipment',
    shiprocketTrackDetails: 'trackShiprocketShipment',
    shreeMarutiTrackDetails: 'trackShreemarutiShipment',
    shadowFxTrackDetails: 'trackShadowfaxShipment',
    atsTrackDetails: 'trackAtsShipment'
  },
  shipNowOrder: {
    dtdc: 'api/order/shipnowOrder',
    delhivery: 'api/order/shipnowOrderForDelhivery',
    expressBase: 'api/order/shipnowOrderXpressbees',
    ekart: 'api/order/shipnowOrderForEkart',
    shiprocket: 'api/order/shipnowOrderForShiprocket',
    bulkOrder: 'api/order/shipBulkOrder',
    shreemaruti: 'api/order/shipNowOrderForShreeMaruti',
    shadwofx: 'api/order/shipnowOrderForShadowfax',
    cancelDelhiveryOrder: 'api/order/cancelDelhiveryOrder',
    cancelShipmentXpressbees: 'api/order/cancelShipmentXpressbees',
    cancelShipmentEKart: 'api/order/cancelEkartOrder',
    cancelShiprocket: 'api/order/cancelShiprocketOrder',
    cancelShreeMaruti: 'api/order/cancelOrderShreeMaruti',
    cancelShadowFx: 'api/order/cancelOrderShadowfax',
    cancelAts: 'api/order/cancelAtsShipment',
    ats: 'api/order/shipnowOrderForAts',
    generateATSLabel: 'api/order/generateATSLabel'
  },
  createOrder: {
    listing: 'api/order/getOrderList',
    listingNew: 'api/order/get',
    getShipnowList: 'api/order/getShipnowList',
    printLabels: 'api/order/printLabels',
    shipmentExelDownload: 'api/order/exportShipmentExcel',
    bulkListing: 'api/product/getProductsForBulkOrder',
    add: 'api/order/createOrder',
    update: 'api/order/updateOrder',
    shipGet: 'api/product/calculateRate',
    bulkShipGet: 'api/order/shipBulkOrder',
    bulkShipment: 'api/order/bulkShipment',
    getBulkOrderJobs: 'api/order/getBulkOrderJobs',
    getJobOrderList: 'api/order/getJobOrderList',
    getBulkJobLabelOptions: 'api/order/getBulkJobLabelOptions',
    printLabelsByJob: 'api/order/printLabelsByJob',
    printLabelsByJobAndProduct: 'api/order/printLabelsByJobAndProduct',
    exportBulkFailedOrdersExcelByJob: 'api/order/exportBulkFailedOrdersExcelByJob',
    exportBulkShipmentExcel: 'api/order/exportBulkShipmentExcel',
    checkBulkOrderProcessing: 'api/order/checkBulkOrderProcessing',
    cancelShipment: 'api/order/cancelShipment',
    cancelBulkShipmet: 'api/order/cancelBulkShipmet',
    deleteOrder: 'api/order/deleteOrder',
    bulkDeleteOrder: 'api/order/bulkDeleteOrder',
    cloneOrder: 'api/order/cloneOrder',
    bulkOrder: 'api/order/createBulkOrder',
    carrierId: 'api/carrier/getServiceAndCarrier',
    shipBulk: 'api/order/shipBulkOrder',
    getFailedOrderDetails: 'api/order/getFailedOrderDetails',
    syncWoocom: 'getAllWooComOrders',
    syncShopify: 'api/order/getAllShopifyOrders'
  },
  orderDetails: {
    listing: 'api/orderDetails/get',
    add: 'api/address/create',
    update: 'api/address/update'
  },
  newPickupAddress: {
    listing: 'api/address/get',
    add: 'api/address/create',
    update: 'api/address/update',
    delete: 'api/address/delete'
  },
  CalculateRate: {
    calculate: 'api/product/calculateUniversalRate'
  },
  LabelSetting: {
    get: 'api/printLabel/get',
    create: 'api/printLabel/create',
    update: 'api/printLabel/update',
    logo: 'api/upload/printLabel',
    manifest: 'api/order/manifestCreate'
  },
  ticket: {
    create: 'api/ticket/create',
    listing: 'api/ticket/list',
    details: 'api/ticket/details',
    addMessage: 'api/ticket/add-message',
    updateStatus: 'api/ticket/update-status',
    messages: 'api/ticket/messages',
    topics: 'api/ticket/topics'
  },
  ndr: {
    listing: 'api/ndrOrder/get',
    ndrfordtdc: 'api/order/createNdrForDtdc',
    shiprocket: 'api/order/createNdrForShiprocket',
    xpressBees: 'api/oredr/createNdrForXpressBees',
    action: 'api/shipments/reattempt',
    viewRequest: 'api/shipments/getRequestRaisedDetails'
  },
  weight_discrepancies: {
    listing: 'api/weightDiscrepancies/get',
    add: 'api/weightDiscrepancies/acceptWeightDiscrepancy',
    submit: 'api/weightDiscrepancies/raiseDispute',
    details: 'api/weightDiscrepancies/getWeightDisputeByWeightDescId'
  },
  codDetails: {
    paidCodList: 'api/codDetails/getCodPaidList',
    payoutSettlementSummary: 'api/codDetails/getPayoutSettlementSummary',
    payoutSettlementDetails: 'api/codDetails/getPayoutSettlementDetails',
    futureCodList: 'api/codDetails/getFutureCodList',
    futureCodPayoutSummary: 'api/codDetails/getFutureCodPayoutSummary',
    futureCodAwbList: 'api/codDetails/getFutureCodAwbList',
    codSummaryReportByCustomer: 'api/codDetails/getCodSummaryReportByCustomer'
  },
  invoice: {
    list: 'api/invoice/getInvoiceDetails',
    single: 'api/invoice/getSingleInvoiceDetails',
    generateSingleShipmentInvoice: 'api/invoice/generateSingleShipmentInvoice',
    excel: 'api/invoice/getInvoiceExcelData',
    raiseRequest: 'api/invoice/raiseRequest'
  },
  warehouse: {
    listing: 'api/address/get',
    add: 'api/address/create',
    update: 'api/address/update',
    delete: 'api/address/delete',
    addWarehouse: 'api/address/setDefault'
  },
  whatsapp: {
    listing: 'api/customerWhatsappConfigurationDetails/get',
    sendOtp: 'api/customerWhatsappConfigurationDetails/send-otp',
    verifyOtp: 'api/customerWhatsappConfigurationDetails/verify-otp',
    update: 'api/customerWhatsappConfigurationDetails/save',
    dashboard: 'api/customerWhatsappConfigurationDetails/dashboard'
  },
  storeConnect: {
    listing: 'api/channelCustomerMapping/get',
    create: 'channelCustomerMapping/createChannel',
    uploadForm: 'upload/uploadProductCatalouge',
    verifyShop: 'verifyShop'
  },
  notifications: {
    getUnopenedCount: 'api/notifications/getUnopenedCount',
    searchNotifications: 'api/notifications/searchNotifications',
    getNotifications: 'api/notifications/getNotifications',
    markAsRead: 'api/notifications/markAsRead',
    markAllRead: 'api/notifications/markAllRead'
  }
};

export default API_URL;
